// ─────────────────────────────────────────────────────────────────
// Glass-i — Fabrication Master API client (Stage 6B.8A-3M).
//
// The backend's public mapper deliberately omits `fabRefName` from
// every response. Treat any `fabRefName` field that does appear as
// untrusted and ignore it on the client too (see helpers).
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/masters/fabrications';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined
    ? resp.data.data
    : resp && resp.data;
}

export const fabricationApi = {
  list:     (params = {}) => client.get(BASE, { params }).then(unwrap),
  lookups:  (params = {}) => client.get(`${BASE}/lookups`, { params }).then(unwrap),
  get:      (id)          => client.get(`${BASE}/${encodeURIComponent(id)}`).then(unwrap),
  create:   (payload)     => client.post(BASE, payload).then(unwrap),
  update:   (id, payload) => client.put(`${BASE}/${encodeURIComponent(id)}`, payload).then(unwrap),
  remove:   (id)          => client.delete(`${BASE}/${encodeURIComponent(id)}`).then(unwrap),
  reorder:  (payload)     => client.post(`${BASE}/reorder`, payload).then(unwrap),
  bulkSave: (payload)     => client.post(`${BASE}/bulk-save`, payload).then(unwrap)
};

export async function loadFabricationLookupsSafe() {
  try { return await fabricationApi.lookups(); }
  catch (_e) { return null; }
}

export default fabricationApi;
